import { parsePhoneNumberFromString } from "libphonenumber-js";
import numeral from "numeral";

export function randomId(length: number) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const charactersLength = characters.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function formatPhone(phone: string) {
  if (!phone) return null;
  const parsed = parsePhoneNumberFromString(phone, "US");
  if (parsed) return parsed.formatNational();
  return phone;
}

export function fileExt(fileName: string) {
  return fileName
    .slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2)
    .toLowerCase();
}

export function fileIsImage(fileName: string) {
  const ext = fileExt(fileName);
  const arr = [
    "jpg",
    "jpeg",
    "tiff",
    "gif",
    "bmp",
    "png",
    "webp",
    "svg",
    "ai",
    "eps",
  ];
  return arr.indexOf(ext) >= 0;
}

export function fileIcon(fileName: string) {
  if (fileIsImage(fileName)) {
    return "fas fa-file-image";
  } else {
    const ext = fileExt(fileName);
    switch (ext) {
      case "doc":
      case "docx":
        return "fas fa-file-word";
      case "xls":
      case "xlsx":
        return "fas fa-file-excel";
      case "ppt":
      case "pptx":
        return "fas fa-file-powerpoint";
      case "pdf":
        return "fas fa-file-pdf";
      case "txt":
        return "fas fa-file-alt";
      case "zip":
        return "fas fa-file-archive";
      case "avi":
      case "wmv":
      case "mov":
      case "qt":
      case "flv":
      case "swf":
      case "mpg":
      case "mpe":
      case "mpv":
      case "mp2":
      case "mp4":
      case "m4p":
      case "m4v":
      case "ogg":
      case "mpeg":
      case "webm":
        return "fas fa-file-video";
      case "csv":
        return "fas fa-file-csv";
      default:
        return "far fa-file";
    }
  }
}

export function fileSize(size: number) {
  return numeral(size).format("0.00 b");
}